import { useTranslation } from "react-i18next";
import React from "react";
import {
  useRateBuilderSettings
} from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";
import { useUnitType } from "@sinch/components/application/Rate/useUnitType";
import { UnitType } from "@sinch/core/entities/serverEnums.types";

export const MinUnitsLabel = ({ unitType, minimumHours }: { unitType: UnitType; minimumHours: number }) => {
  const { t } = useTranslation(["common", "draft"]);
  const { rateType } = useRateBuilderSettings();
  const { getUnitFormatter } = useUnitType(rateType);
  return (
    <span>
      {t("RateBuilder.minUnits", {
        units: getUnitFormatter(unitType)?.(minimumHours) ?? minimumHours,
      })}
    </span>
  );
};
